import React from 'react';
import { StarIcon, BadgeCheckIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Maria Rossi',
    age: '34 anni',
    city: 'Roma, Italia',
    initials: 'MR',
    text: 'Questo Mega-Pack ha completamente trasformato il mio modo di insegnare educazione fisica. Ora preparo le lezioni in metà del tempo!',
    color: 'bg-blue-500'
  }, {
    name: 'Giuseppe Bianchi',
    age: '42 anni',
    city: 'Milano, Italia',
    initials: 'GB',
    text: 'I percorsi psicomotori sono fantastici. I miei studenti sono molto più coinvolti e motivati durante le lezioni.',
    color: 'bg-green-500'
  }, {
    name: 'Francesca Conti',
    age: '29 anni',
    city: 'Napoli, Italia',
    initials: 'FC',
    text: "Finalmente un materiale organizzato e pronto all'uso. Non devo più cercare ore su internet per trovare attività adatte.",
    color: 'bg-purple-500'
  }, {
    name: 'Luca Moretti',
    age: '38 anni',
    city: 'Torino, Italia',
    initials: 'LM',
    text: 'Le schede di valutazione e le pianificazioni mi hanno semplificato enormemente il lavoro. Consigliatissimo!',
    color: 'bg-orange-500'
  }, {
    name: 'Elena Ferrara',
    age: '45 anni',
    city: 'Firenze, Italia',
    initials: 'EF',
    text: 'Ho acquistato molti materiali in passato, ma nessuno era così completo e ben organizzato. Vale ogni centesimo.',
    color: 'bg-teal-500'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-286">
      <div className="max-w-6xl mx-auto" data-id="element-287">
        <div className="text-center mb-16" data-id="element-288">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-289">
            Cosa dicono gli insegnanti
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-290">
            Oltre 2.500 insegnanti di educazione fisica utilizzano già i nostri
            materiali con successo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-291">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-50 rounded-2xl p-6 border border-gray-100 shadow-sm relative flex flex-col" data-id="element-292">
              <div className="flex items-center justify-between mb-4" data-id="element-293">
                <div className="flex text-yellow-400" data-id="element-294">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-current" data-id="element-295" />)}
                </div>
                <div className="flex items-center gap-1 text-green-600 text-xs font-bold bg-green-50 px-2 py-1 rounded-full" data-id="element-296">
                  <BadgeCheckIcon className="w-3 h-3" data-id="element-297" />
                  Acquisto Verificato
                </div>
              </div>

              <p className="text-gray-700 italic mb-6 leading-relaxed flex-1" data-id="element-298">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 pt-4 border-t border-gray-200" data-id="element-299">
                <div className={`w-12 h-12 rounded-full ${t.color} flex items-center justify-center text-white font-bold text-lg shadow-inner`} data-id="element-300">
                  {t.initials}
                </div>
                <div data-id="element-301">
                  <p className="font-bold text-gray-900 leading-tight" data-id="element-302">
                    {t.name}
                  </p>
                  <p className="text-xs text-gray-500" data-id="element-303">
                    {t.age} • {t.city}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}